import PublicExplanations from '@public/images/fintech-and-banking/public-explanations.png'

import TextWithImageGoingOffScreen from '@/components/TextWithImageGoingOffScreen/TextWithImageGoingOffScreen'

export default function AuditReadyFintech() {
    return (
        <TextWithImageGoingOffScreen
            title={`Audit-ready calculation breakdowns`}
            paragraph={`Fast-track your customers’ climate compliance with step-by-step emission calculation breakdowns. Make their reports audit-ready by sharing how emissions were calculated and what assumptions were made.`}
            img={PublicExplanations}
        />
    )
}
